import { put } from 'redux-saga/effects';
import { addToClickLog } from 'actions/logActions';

export function* designModeClickLogger(action) {
    if (action) {
        const designMode = action.designMode ? action.designMode : "exit"
        yield put(addToClickLog({ event: "Design mode click: " + designMode }));
    }
}
